/**
 * Main User Interface Actions
 * @type {Object}
 */
SITE.UI = {

    viewport: {
        width: 0,
        height: 0,
        mode: "", // xl, lg, md, sm, xs
        touch: false,
        scrollTop: 0
    },

    breakpoints: {
        "xs": 0,
        "sm": 576,
        "md": 768,
        "lg": 992,
        "xl": 1200
    },

    containerWidths: {
        "sm": 576,
        "md": 750,
        "lg": 960,
        "xl": 1100
    },

    init: function() {
        "use strict";

        SITE.UI.Size.init();
        SITE.UI.Audio.init();
        
        $('#hamburger').on('click', function(){
            $(this).toggleClass('is-active');
            $('body').toggleClass('is-mobilemenu-active');
        });
        
        //dev
        // $('body').toggleClass('is-mobilemenu-active');

    },

    Audio: {
        getPlayer: function(){
            return $('.sppaudioplayer')[0] || null;
        },
        skipTo: function(timestamp){
            var player = SITE.UI.Audio.getPlayer();
            if (player){
                player.currentTime = timestamp;
                player.play();
            }
        },
        attachListeners: function(){
            // Get timestamps from content area
            // and wrap them with attributes
            var re = /\[(\d\d)\:(\d\d)\]/g;
            $(".wysiwyg ul").each(function(){
                $el = $(this);
                $el.html($el.html().replace(re, '<a data-site-audio-skipto="$1|$2">$&</a>'))
            });

            // Attach click listener on wrapped timestamps
            $('[data-site-audio-skipto]').on('click', function(){
                var timestamp = $(this).data('site-audio-skipto').split('|');
                timestamp = ~~timestamp[0]*60+~~timestamp[1];
                SITE.UI.Audio.skipTo(timestamp);
            });
        },
        init: function(){
            console.log('Audio', SITE.UI.Audio.getPlayer());
            if (SITE.UI.Audio.getPlayer()){
                SITE.UI.Audio.attachListeners();
            }
        }
    },
    Size: {

        init: function() {
            "use strict";

            SITE.UI.Size.set();
            if (SITE.debugOn === true) SITE.UI.Size.show();

            $(window).resize(function() {
    
                SITE.UI.Size.set();
                if (SITE.debugOn === true) SITE.UI.Size.show();
            });

        },

        set: function() {
            "use strict";
            
            var w;
            
            SITE.UI.viewport.width = w = $(window).width();
            SITE.UI.viewport.height = $(window).height();

            $.each(SITE.UI.breakpoints, function(mode, width) {
                if (w > width) SITE.UI.viewport.mode = mode;
            });
            
        },

        show: function() {
            "use strict";

            if(window.location.hostname == 'growtheverywhere.local') {
                if ($("#screenSize").length == 0) {
                    $("body").append("<div id='screenSize' style='padding: 10px; background: red; color: white;position: fixed; right: 0; bottom: 0'></div>");
                }

                $("#screenSize").text(SITE.UI.viewport.mode);
            }

        }
    }

}